module.exports = __webpack_public_path__ + "fonts/icomoon.2387020.eot";